@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title}}" [(visible)]="display" showEffect="fade" [modal]="true" [style]="{ width: '40vw' }" appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- NAME & PROVIDER -->
      <div class="row mt-3">
        <!-- NAME -->
        <div class="col-md-6">
          <label for="cardType-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.name' | translate}}
                </label>
          <input type="text" id="cardType-name" class="form-control custom-input" [(ngModel)]="entity.name">
        </div>
        <!-- PROVIDER -->
        <div class="col-md-6">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'promotedRoutes.providerName' | translate}}
                </label>
          <div class="p-0"></div>
          <p-select [options]='selectableProviders' [(ngModel)]='selectedprovider'
            dataKey='id' optionLabel='name' [style]="{'width':'100%'}" appendTo='body' filter="true" filterBy="name"
            (onChange)="onChangeProvider($event)"
            [compareWith]="compareByIdAndName"
            (onFilter)="onFilterProvider($event)">
          </p-select>
        </div>
      </div>
      <!-- CODE PRODUCT LIMIT & PRODUCT LIMIT -->
      <div class="row mt-3">
        <!-- CODE PRODUCT LIMIT -->
        <div class="col-md-6">
          <label for="cardType-cpLimit" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'tableManagement.cardTypes.codeProductLimit' | translate}}
                </label>
          <input type="text" id="cardType-cpLimit" class="form-control custom-input"
            [(ngModel)]="entity.codeProductLimit">
        </div>
        <!-- PRODUCT LIMIT -->
        <div class="col-md-6">
          <label for="cardType-productLimit" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'tableManagement.cardTypes.productLimit' | translate}}
                </label>
          <input type="number" id="cardType-productLimit" class="form-control custom-input"
            [(ngModel)]="entity.productLimit">
        </div>
      </div>
      <!-- OPERATION LIMIT & ACTIVE -->
      <div class="row mt-3">
        <!-- OPERATION LIMIT -->
        <div class="col-md-6">
          <label for="cardType-operationLimit" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'tableManagement.cardTypes.operationLimit' | translate}}
                </label>
          <input type="number" id="cardType-operationLimit" class="form-control custom-input"
            [(ngModel)]="entity.operationLimit">
        </div>
        <!-- ACTIVE -->
        <div class="col-md-6">
          <label for="cardType-enabled" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.active' | translate }}
                </label>
          <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
            type="checkbox" [(ngModel)]="active">
        </div>
      </div>
      <div class="row mt-2 mb-4">
        <div class="col-auto position-relative mt-3 p-0 card-image-wrapper">
          <!-- PROFILE IMAGE -->
          <img #image src="{{cardTypeEncodedImage}}" class="custom-user-profile-image d-block p-0">
          <!-- ADD IMAGE BUTTON -->
          <div id="outer-icon-holder" class="d-flex align-items-center justify-content-center position-absolute bottom-0 end-0">
            <div id="inner-icon-holder" class="d-flex align-items-center justify-content-center"
              (click)='uploadImageInput.click()'>
              <img src="assets/icons/camera-plus.png" class="custom-user-profile-icon" />
              <input #uploadImageInput [hidden]='true' type='file' accept='.jpg, .png'
                (change)='imageChange($event)'>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- #endregion BODY -->
  </div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="saveCardType()" i18n>
                        {{'general.create' | translate}}
                    </button>
            </div>
          }
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="saveCardType()" i18n>
                        {{'general.save' | translate}}
                    </button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(!active)" i18n>
                        {{'general.changeStatus' | translate}}
                    </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}